import * as React from 'react'
import { View, ViewStyle } from 'react-native'
import { Color, colors, Radius, radii } from './theme/index'
import { spacing, SpacingSize, AlignX, AlignY, alignXToFlexAlign, alignYToFlexAlign } from './types'

interface SpreadProps {
	children: React.ReactNode
	space?: SpacingSize
	alignX?: AlignX
	alignY?: AlignY
	padding?: SpacingSize
	paddingX?: SpacingSize
	paddingY?: SpacingSize
	margin?: SpacingSize | 'auto'
	marginX?: SpacingSize | 'auto'
	marginY?: SpacingSize | 'auto'
	background?: Color
	borderRadius?: Radius
	style?: ViewStyle
}

export function Spread({
	children,
	space = 'md',
	alignX = 'spaceBetween',
	alignY = 'center',
	padding,
	paddingX,
	paddingY,
	margin,
	marginX,
	marginY,
	background = 'transparent',
	borderRadius = 'none',
	style,
}: SpreadProps) {
	const spreadStyle: ViewStyle = {
		flexDirection: 'row',
		justifyContent: alignXToFlexAlign[alignX],
		alignItems: alignYToFlexAlign[alignY],
		backgroundColor: colors[background],
		borderRadius: radii[borderRadius],
		width: '100%',
		...(padding && {
			padding: spacing[padding],
		}),
		...(paddingX && {
			paddingHorizontal: spacing[paddingX],
		}),
		...(paddingY && {
			paddingVertical: spacing[paddingY],
		}),
		...(margin && {
			margin: margin === 'auto' ? 'auto' : spacing[margin],
		}),
		...(marginX && {
			marginHorizontal: marginX === 'auto' ? 'auto' : spacing[marginX],
		}),
		...(marginY && {
			marginVertical: marginY === 'auto' ? 'auto' : spacing[marginY],
		}),
		...style,
	}

	// Add spacing between children
	const childrenWithSpacing = React.Children.toArray(children).map((child, index, array) => {
		if (index === array.length - 1) return child
		return (
			<React.Fragment key={index}>
				{child}
				<View style={{ width: spacing[space] }} />
			</React.Fragment>
		)
	})

	return <View style={spreadStyle}>{childrenWithSpacing}</View>
}
